import { CircularProgress, Stack, Tooltip } from "@mui/material"
import Label from "minimals-template/components/Label"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING } from "routes/asset-register/plugins/asset-mapping/feature-flag-mobiliser-advanced-mapping.runtime"

const statusLabelInfo = {
    mapping: {
        label: "Mapping",
        tooltip: "Mapping in progress",
        color: "primary",
        spinner: true,
    },
    excluded: {
        label: "Excluded",
        tooltip: "Excluded from mapping",
        color: "error",
    },
    todo: {
        label: "To Do",
        tooltip: "Not yet mapped",
        color: "primary",
    },
    mapped: {
        label: "Mapped",
        color: "success",
    },
    auto: {
        label: "Mapped (Auto)",
        tooltip: "Mapped automatically by Mobiliser",
        color: "success",
    },
    assisted: {
        label: "Mapped (AI-assisted)",
        tooltip: "Mapped by a user using Mobiliser suggestions",
        color: "success",
    },
    manual: {
        label: "Mapped (Manual)",
        tooltip: "Mapped manually outside Mobiliser suggestions",
        color: "success",
    },
    legacy: {
        label: "Mapped",
        color: "success",
    },
}

export function AssetTypeStatus({ item, isMapped, isIntelligentMapped, isMapping }) {
    const { isManualMapTab } = useBoundContext()
    const upgradesEnabled = isEnabled(FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING)
    const status = getStatus()
    const { label, tooltip = "", color, spinner } = statusLabelInfo[status] ?? statusLabelInfo.legacy

    return (
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
            <Tooltip
                title={tooltip}
                arrow
                describeChild
                slotProps={{ tooltip: { "data-cy": "asset-type-status-tooltip" } }}
            >
                <Label
                    data-cy="asset-type-status-label"
                    data-origin={status}
                    color={color}
                    startIcon={spinner && <CircularProgress size={12} thickness={5} sx={{ color: "inherit" }} />}
                    sx={{ minWidth: 100, height: 28, fontSize: 14, px: 1.25, borderRadius: 1 }}
                >
                    {label}
                </Label>
            </Tooltip>
        </Stack>
    )

    function getStatus() {
        const isExcluded = !!item.doNotMap && item.doNotMap !== "create"
        if (upgradesEnabled) {
            if (isExcluded) return "excluded"
            if (isMapping && item.doNotMap !== "create") return "mapping"
        } else {
            if (isMapping) return "mapping"
            if (isExcluded) return "excluded"
        }
        if (!isMapped) return "todo"
        if (isManualMapTab) return "mapped"
        return item.mappingOrigin ?? (isIntelligentMapped ? "legacy" : "manual")
    }
}
